import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const QuienesSomosPage = lazy(() => import('../pages/quienes-somos/page'));
const EmpresasPage = lazy(() => import('../pages/empresas/page'));
const ContactoPage = lazy(() => import('../pages/contacto/page'));
const OportunidadPage = lazy(() => import('../pages/oportunidad/page'));
const CarrerasPage = lazy(() => import('../pages/oportunidades-laborales/page'));
const RecursosPage = lazy(() => import('../pages/recursos/page'));
const BackOfficePage = lazy(() => import('../pages/backoffice/page'));
const FAQPage = lazy(() => import('../pages/faq/page'));
const LibroReclamacionesPage = lazy(() => import('../pages/libro-reclamaciones/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/quienes-somos',
    element: <QuienesSomosPage />,
  },
  {
    path: '/empresas',
    element: <EmpresasPage />,
  },
  {
    path: '/oportunidad',
    element: <OportunidadPage />,
  },
  {
    path: '/oportunidades-laborales',
    element: <CarrerasPage />,
  },
  {
    path: '/recursos',
    element: <RecursosPage />,
  },
  {
    path: '/faq',
    element: <FAQPage />,
  },
  {
    path: '/BackofficeInkavida',
    element: <BackOfficePage />,
  },
  {
    path: '/soporte',
    element: <ContactoPage />,
  },
  {
    path: '/libro-reclamaciones',
    element: <LibroReclamacionesPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;